/**
 * The four standard intents
 */
export const Intent = {
  NONE: 'none' as const,
  PRIMARY: 'primary' as const,
  SECONDARY: 'secondary' as const,
  TERTIARY: 'tertiary' as const,
  QUATERNARY: 'quaternary' as const,
  QUINARY: 'quinary' as const,
  SUCCESS: 'success' as const,
  WARNING: 'warning' as const,
  DANGER: 'danger' as const,
};

export type Intent = (typeof Intent)[keyof typeof Intent];
